import React, { useEffect, useMemo, useState } from "react";
import { toast, Toaster } from "sonner";
import DashboardShell from "../../components/layout/DashboardShell";
import { Pill, Button } from "../../components/common/Primitives";
import AdminListSearch from "../../components/common/AdminListSearch";
import api, { formatApiError } from "../../lib/api";

export default function AdminInterests() {
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState("");
  const load = () => api.get("/admin/interests").then((r) => setRows(r.data || []));
  useEffect(() => { load(); }, []);
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((r) => {
      const hay = [r.investor_name, r.startup_name, r.status].filter(Boolean).join(" ").toLowerCase();
      return hay.includes(q);
    });
  }, [rows, query]);

  const openDealRoom = async (r) => {
    try {
      await api.post("/admin/deal-rooms", { interest_id: r.interest_id, deal_summary: `${r.investor_name} × ${r.startup_name}` });
      toast.success("Deal room opened.");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <DashboardShell title="Investor Interests" subtitle="ADMIN · INTEREST WORKFLOW">
      <Toaster richColors position="top-right" />
      <AdminListSearch
        value={query}
        onChange={setQuery}
        placeholder="Search by investor, startup, status…"
        testId="admin-interests-search"
        count={filtered.length}
      />
      <div className="border border-white/10 bg-white/70 backdrop-blur overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-widest text-ink-muted">
            <tr className="border-b border-white/10">
              <th className="text-left px-4 py-3">Investor</th>
              <th className="text-left px-4 py-3">Startup</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">At</th>
              <th className="text-left px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.interest_id} className="border-b border-white/5">
                <td className="px-4 py-3 text-ink">{r.investor_name || "—"}</td>
                <td className="px-4 py-3 text-ink">{r.startup_name || "—"}</td>
                <td className="px-4 py-3"><Pill tone="gold">{r.status}</Pill></td>
                <td className="px-4 py-3 text-ink-muted font-mono text-xs">{r.created_at?.slice(0, 10)}</td>
                <td className="px-4 py-3">
                  {r.status !== "Deal Room Opened" && (
                    <Button variant="dark" onClick={() => openDealRoom(r)} data-testid={`open-dealroom-${r.interest_id}`}>Open Deal Room</Button>
                  )}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={5} className="text-center py-10 text-ink-faint">
                {rows.length === 0 ? "No interests yet." : "No interests match your search."}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
